// extracted by mini-css-extract-plugin
module.exports =  {"arrowPopupMenu":"ArrowPopupMenu__arrowPopupMenu--WA","anchor":"ArrowPopupMenu__anchor--uS"};